import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-glass-info-modal',
  templateUrl: './glass-info-modal.component.html',
  styleUrls: ['./glass-info-modal.component.scss'],
  standalone: false,
})
export class GlassInfoModalComponent {
  @Input() glass: any;

  constructor(private modalController: ModalController) {}

  close() {
    this.modalController.dismiss();
  }

  getCavityDisplay(): string {
    if (this.glass.cavities && Array.isArray(this.glass.cavities)) {
      return this.glass.cavities.join(', ');
    }
    return this.glass.cavity || '-';
  }
}
